import { render, staticRenderFns } from "./IlluEnseignant2.vue?vue&type=template&id=4cf296b6&"
import script from "./IlluEnseignant2.vue?vue&type=script&lang=js&"
export * from "./IlluEnseignant2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports